// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Create from '../components/Question/Create/Create';
import { Redirect } from 'react-router-dom';

@inject('userStore')
@observer class CreateQuestionRoute extends Component<any, any> {
	render() {
		if(this.props.userStore.user) {
			return (
				<Create />
			)
		} else {
			return (<Redirect to="/?login=true" />)
		}
	}
}

export default CreateQuestionRoute;

